"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Network = void 0;
require("ag-grid-community/dist/styles/ag-grid.css");
require("ag-grid-community/dist/styles/ag-theme-balham.css");
const ag_grid_react_1 = require("ag-grid-react");
const ui_1 = require("client/components/ui");
const store_1 = require("client/modules/reporting/store");
const mobx_react_1 = require("mobx-react");
const React = require("react");
const react_1 = require("react");
const no_data_found_1 = require("../no-data-found/no-data-found");
const network_header_1 = require("./components/network-header");
require("./network.less");
let Network = class Network extends react_1.Component {
    constructor(props) {
        super(props);
        this.onButtonExport = () => {
            const params = {
                fileName: "Network_Contacts.csv"
            };
            this.storeData.gridApi.exportDataAsCsv(params);
        };
        this.storeData = {
            defaultColDef: {
                enablePivot: true,
                enableRowGroup: true,
                enableValue: true,
                sortable: true,
                resizable: true,
                filter: true,
                comparator(a, b) {
                    if (typeof a === "string") {
                        return a.localeCompare(b);
                    }
                    return a > b ? 1 : a < b ? -1 : 0;
                }
            },
            columnDefs: [
                {
                    headerName: "Type",
                    field: "type",
                    enableRowGroup: true
                },
                {
                    headerName: "Pharmacy",
                    field: "site"
                },
                {
                    headerName: "Prefix",
                    field: "prefix"
                },
                {
                    headerName: "First Name",
                    field: "firstName"
                },
                {
                    headerName: "Last Name",
                    field: "lastName"
                },
                {
                    headerName: "Suffix",
                    field: "suffix"
                },
                {
                    headerName: "Phone",
                    field: "phone"
                },
                {
                    headerName: "Email",
                    field: "email"
                },
                {
                    headerName: "Notes",
                    field: "notes"
                },
                {
                    headerName: "Provider Title",
                    field: "title"
                },
                {
                    headerName: "User Group",
                    field: "groupName"
                },
                {
                    headerName: "Distributor Name",
                    field: "distributorName"
                },
                {
                    headerName: "Distributor Account",
                    field: "accountNumber"
                }
            ],
            rowSelection: "single",
            rowData: [],
            multiSortKey: "ctrl",
            floatingFilter: true
        };
    }
    async componentDidMount() {
        await store_1.reportsStore.loadNetworkContacts();
    }
    componentWillUnmount() {
        store_1.reportsStore.networkContactsData = null;
    }
    render() {
        const storeData = store_1.reportsStore.networkContactsData;
        this.storeData.rowData = storeData;
        const loadingData = store_1.reportsStore.showLoader;
        if (storeData && storeData.length > 0) {
            return (React.createElement(React.Fragment, null,
                React.createElement(network_header_1.NetworkHeader, { title: "Network Contacts", withDatePicker: true }),
                React.createElement("div", { className: "ag-theme-balham", style: {
                        height: "85%",
                        width: "100%"
                    } },
                    React.createElement("button", { onClick: this.onButtonExport.bind(this) }, "Export to CSV"),
                    React.createElement(ag_grid_react_1.AgGridReact, { onGridReady: params => (this.storeData.gridApi = params.api), rowSelection: this.storeData.rowSelection, columnDefs: this.storeData.columnDefs, defaultColDef: this.storeData.defaultColDef, frameworkComponents: this.storeData.frameworkComponents, multiSortKey: this.storeData.multiSortKey, animateRows: true, sideBar: true, groupMultiAutoColumn: true, floatingFilter: this.storeData.floatingFilter, suppressExcelExport: true, rowData: this.storeData.rowData }))));
        }
        if (storeData) {
            if (loadingData) {
                return (React.createElement(React.Fragment, null,
                    React.createElement(network_header_1.NetworkHeader, { title: "Network Contacts", withDatePicker: true }),
                    React.createElement("div", null, "Loading Data...")));
            }
            // Return a Custom built component here to handle 0 data returned.
            return (React.createElement(no_data_found_1.default, { headerComponent: React.createElement(network_header_1.NetworkHeader, { title: "Network Contacts", withDatePicker: true }) }));
        }
        return React.createElement(ui_1.UiLoadingIndicator, null);
    }
};
Network = __decorate([
    mobx_react_1.observer
], Network);
exports.Network = Network;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/reporting/modules/reporting-list/components/report-container/network/network.tsx
// module id = 3937
// module chunks = 0